export default function findIndex(dataView: DataView, typedArray) {
    const target = new Uint8Array(typedArray);

    // find index of target array in dataView
    for (let i = 0; i < dataView.byteLength - target.byteLength + 1; i++) {
        let match = true;
        for (let j = 0; j < target.byteLength; j++) {
            if (dataView.getUint8(i + j) !== target[j]) {
                match = false;
                break;
            }
        }
        if (match) {
            return i;
        }
    }

    return -1;
}
